import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Dropdown, MenuProps } from 'antd';
import React from 'react';
import './languageChanger.scss';
import { countryFlag } from '../../functions';

type languageType = {
  [languageKey: string]: {
    label: string;
    flag?: JSX.Element;
  };
};

type i18nType = {
  language: string;
  changeLanguage: Function;
};

export interface propsType {
  i18n: i18nType;
  env: string;
  isMenuOpen: boolean;
  t: Function;
}

export const LanguageChanger = ({ i18n, env, t, isMenuOpen }: propsType) => {
  const getLangIndex: string = localStorage.getItem('i18nLanguage') ?? 'fr-FR';

  const languages: languageType = {
    'fr-FR': {
      label: t('APP.LANGUAGECHANGER.INDEX.PH_598F35', {
        defaultValue: 'Français - FR',
      }),
      flag: countryFlag(
        'fr-FR',
        t('APP.LANGUAGECHANGER.INDEX.PH_598F35', {
          defaultValue: 'Français - FR',
        })
      ),
    },
    'en-GB': {
      label: t('APP.LANGUAGECHANGER.INDEX.PH_6ECE4F', {
        defaultValue: 'English - UK',
      }),
      flag: countryFlag(
        'en-GB',
        t('APP.LANGUAGECHANGER.INDEX.PH_6ECE4F', {
          defaultValue: 'English - UK',
        })
      ),
    },
    dev: {
      label: t('APP.LANGUAGECHANGER.INDEX.PH_8475A5', {
        defaultValue: 'Debug mode',
      }),
    },
  };

  const changeLanguage = (lng: string) => {
    localStorage.setItem('i18nLanguage', lng);
    i18n.changeLanguage(lng);
    location.reload();
  };

  const items: MenuProps['items'] = Object.entries(languages)
    .filter(([key]) => key !== 'dev')
    .map(([key, lang]) => ({
      label: lang.label,
      key,
      onClick: () => changeLanguage(key),
      ...(lang.flag ? { icon: lang.flag } : {}),
    }));

  if (env === 'dev' || env === 'testing' || env === 'staging') {
    items.push({
      label: languages.dev.label,
      key: 'dev',
      onClick: () => changeLanguage('cimode'),
    });
  }

  return (
    <>
      <Dropdown
        placement="bottom"
        menu={{ items }}
        overlayClassName="languageChanger_select"
      >
        <div className={`languageChanger`}>
          <div className="languageChanger_container">
            <div className="languageChanger_container_text">
              {i18n.language !== 'cimode' ? (
                <>{languages[getLangIndex].flag}</>
              ) : (
                'debug mode'
              )}
            </div>
            {isMenuOpen && (
              <div>
                <KeyboardArrowDownIcon />
              </div>
            )}
          </div>
        </div>
      </Dropdown>
    </>
  );
};
